export const parallaxVariables = {
  topPositionNew: 0,
  topPosition: 0,
  imgHt: 0,
}

export const calculateTop = (topPosition: number, posFactor: number, originalTop: number): number => {
  const factor = topPosition * posFactor + originalTop
  return factor
}

export const calculatePosFactor = (imageHt: number, originalTop: number, containerHt: number): number => {
  return -(imageHt * 0.15 + originalTop) / (window.innerHeight - containerHt)
}
